<template>
  <div>
    <el-row class="cs-accountInfo-row">
      <el-col>
        <span class="cs-title">支付详情</span>
        <span class="payee-type" v-if="!canEditPayeeType">{{this.GLOBAL.enumPayeeType.getDesc(this.model.payeeType)}}</span>
      </el-col>
    </el-row>
    <!-- <el-row v-if="payeeTypeEditable && !isReadonly" class="cs-accountInfo-row">
      <el-col>
        <div>
          <el-select size="small" v-model="model.payeeType" placeholder="请选择收款方" @change="onPayeeTypeChange">
            <el-option v-for="item in this.GLOBAL.enumPayeeType.getOptions()" :key="item.value" :label="item.desc" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row> -->

    <el-row v-if="canEditPayeeType" class="cs-accountInfo-row">
      <el-col :span="10">
        <span class="cs-label">收款方式:</span>
      </el-col>
      <el-col :span="14">
        <el-select size="small" v-model="model.payeeType" :disabled="payeeTypeDisabled" placeholder="请选择收款类型">
          <el-option v-for="(item, index) in GLOBAL.enumPayeeType.getOptions()" :key="index" :label="item.desc"
            :value="item.value"></el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row v-show="model.payeeType == 1" class="cs-accountInfo-row">
      <el-col :span="10">
        <span class="cs-label">服务费到账状态</span>
      </el-col>
      <el-col :span="14">
        <div
          v-if="!isReadonly">
          <el-select size="small" v-model="model.paymentReceived" placeholder="请选择是否到账" style="width: 70%;">
            <el-option v-for="item in paymentReceivedList" :key="item.Key" :label="item.Value" :value="item.Key" />
          </el-select>
          <el-button :loading="isPaymentReceivedSaving" :disabled="isPaymentReceivedSaving" v-show="model.paymentReceived !== originalModel.paymentReceived && !disabledSave" size="small" type="text"
            style="margin-left: 5px;" @click="savePaymentReceived">保存</el-button>
        </div>
        <div v-else>
          <span>{{getPaymentReceivedText()}}</span>
        </div>
      </el-col>
    </el-row>
    <el-row class="cs-accountInfo-row" v-show="model.payeeType == 0">
      <el-col>
        <paymentListView :dataList="accountModel.AccountPayments" :options="{
            enableEdit: !isReadonly && !disabledEdit && paymentEditable,
            enableRemove: !isReadonly && !disabledRemove && paymentEditable,
            displayType: displayType,
            currency: dataIn.currency
          }" @item-click="onPaymentListViewItemClick" @item-remove="onPaymentListViewItemRemove"></paymentListView>
      </el-col>
    </el-row>
    <el-row class="cs-accountInfo-row" v-show="model.payeeType == 0">
      <el-col>
        <el-button v-if="!disabledAdd && !isReadonly && paymentEditable" :loading="isSavePayment" size="medium" :disabled="isSavePayment"
          type="primary" @click="showAddPaymentEditor">添加支付</el-button>
      </el-col>
    </el-row>

    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="paymentEditorVisible" top="3vh">
      <paymentEditor key="paymentEditor" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :currency="dataIn.currency"
        :options="paymentEditorOptions" :data="paymentEditorData" @closeDialog="onPaymentEditorClose"
        @callback="onPaymentEditorCallback"></paymentEditor>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.cs-title {
  display: inline !important;
  font-weight: bold;
  margin-right: 10px;
}

.cs-label {
  font-weight: bold;
  font-size: 16px;
}

.cs-accountInfo-row {
  margin-bottom: 20px;

  .el-col {
    line-height: 32px;
  }
}

.payee-type {
  background-color: #e9f0f7;
  color: #006ab4;
  padding: 5px 8px;
  border-radius: 5px;
  font-weight: bold;
  line-height: 30px;
}
</style>

<script>
import paymentEditor from "../common/paymentEditor";
import paymentListView from "../common/paymentListView";

import {
  getAccountByWorkflowId,
  updateIsPaymentReceived,
} from "../../service/studyAbroad.service";
import {
  createAccountModel,
  saveAccount,
  removeAccountPayment,
  saveContinueAccountPayment,
} from "../../service/finance.service.js";

export default {
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
    displayType: {
      type: String,
      default: "normal",
      validator: (value) => ["normal", "simple", "list"].contains(value),
    },
    payeeTypeEditable: {
      type: Boolean,
      default: true,
    },
    paymentEditable: {
      type: Boolean,
      default: true,
    },
    disabledAdd: {
      type: Boolean,
      default: false,
    },
    disabledEdit: {
      type: Boolean,
      default: false,
    },
    disabledRemove: {
      type: Boolean,
      default: false,
    },
    disabledSave: {
      type: Boolean,
      default: false,
    },
    workMode: String,
    dataIn: {
      studentId: {
        type: [Number, String],
        default: 0,
      },
      workflowId: {
        type: [Number, String],
        default: 0,
      },
      currency: Number,
      accountAmount: Number,
      model: Object,
    },
  },
  components: {
    paymentEditor,
    paymentListView,
  },
  data() {
    return {
      paymentReceivedList: [
        { Key: 0, Value: "未到账" },
        { Key: 1, Value: "已到账" },
      ],
      model: {
        paymentReceived: 0,
        businessType: 0,
        payeeType: 0,
      },
      originalModel: {
        paymentReceived: 0,
      },
      accountModel: {
        AccountPayments: [],
      },
      paymentEditorData: {
        index: -1,
        item: null,
      },
      isSavePayment: false,
      paymentEditorVisible: false,
      paymentEditorOptions: {
        showTitle: true,
        allowPaidCount: 0,
        closeOnSaveDisabled: true,
        showAccountAmountLeft: true,
      },
      editIndex: -1,
      editPayment: null,
      isPayeeTypeSaving: false,
      isPaymentReceivedSaving: false
    };
  },
  created() {
    this.$nextTick(async () => {
      this.init();
    });
  },
  computed: {
    canEditPayeeType: function() {
       let condition1 = !this.isReadonly && this.payeeTypeEditable && this.model.businessType === this.GLOBAL.enumBusinessType.ToB;
       let condition2 = true;
       switch (this.model.payeeType) {
         case this.GLOBAL.enumPayeeType.Speedup:
           if (!!this.accountModel && this.accountModel.AccountPayments.length > 0)
            condition2 = false;
           break;
          case this.GLOBAL.enumPayeeType.Channel:
            if (this.originalModel.paymentReceived)
              condition2 = false;
            break;
       }

       return condition1 && condition2;
    },
    payeeTypeDisabled: function() {
      let result = false;
       switch (this.model.payeeType) {
         case this.GLOBAL.enumPayeeType.Speedup:
           if (!!this.accountModel && this.accountModel.AccountPayments.length > 0)
            result = true;
           break;
          case this.GLOBAL.enumPayeeType.Channel:
            if (this.model.paymentReceived)
              result = true;
            break;
       }

       return result;
    },
    totalServiceCharge: function () {
      if (this.accountModel && this.accountModel.AccountPayments) {
        let total = this.accountModel.AccountPayments.reduce(
          (sum, x) => sum + x.ServiceCharge,
          0
        );
        return total;
      }
      return 0;
    },
    totalPayment: function () {
      if (this.accountModel && this.accountModel.AccountPayments) {
        let total = this.accountModel.AccountPayments.reduce(
          (sum, x) => sum + x.Amount,
          0
        );
        return total;
      }
      return 0;
    },
    accountAmountLeft: function () {
      if (!!this.dataIn) {
        let value = this.dataIn.accountAmount - this.totalPayment;
        if (value < 0) {
          value = 0;
        }
        return value;
      }
      return 0;
    },
  },
  methods: {
    init() {
      if (!!this.dataIn && !!this.dataIn.model) {
        this.model = this.dataIn.model;
        this.originalModel = Object.clone(this.model);
        this.loadAccountModel();
      }
    },
    getPaymentReceivedText() {
      let item = this.paymentReceivedList.find(
        (i) => i.Key == this.model.paymentReceived
      );
      if (!!item) {
        return item.Value;
      }

      return "";
    },
    savePaymentReceived() {
      let isPaymentReceived = this.model.paymentReceived == 1;
      this.isPaymentReceivedSaving = true;
      updateIsPaymentReceived(this.dataIn.workflowId, isPaymentReceived).then(
        (result) => {
          if (!!result && result.success) {
            if (result.data) {
              this.$message.success("修改到账状态成功");
              this.originalModel = Object.clone(this.model);
            } else {
              this.$message.success("修改到账状态失败");
            }
          } else {
            this.$message.success("修改到账状态失败, " + result.message);
          }
          this.isPaymentReceivedSaving = false;
        }
      );
    },
    loadAccountModel() {
      if (
        !!this.dataIn &&
        !!this.dataIn.studentId &&
        !!this.dataIn.workflowId
      ) {
        getAccountByWorkflowId(
          this.dataIn.studentId,
          this.dataIn.workflowId
        ).then((result) => {
          if (!!result && result.success) {
            this.accountModel = result.data;
            this.handleAccountLoading();
          } else {
            this.$message({
              showClose: true,
              message: result.message,
              type: "error",
              duration: 0,
            });
          }
        });
      }
    },
    handleAccountLoading() {
      this.$emit("loadAccount", {
        totalServiceCharge: this.totalServiceCharge,
        totalPayment: this.totalPayment,
        accountAmountLeft: this.accountAmountLeft,
      });
    },
    reloadDataForPaymentEditor() {
      let newData = {
        index: -1,
        item: null,
        accountAmountLeft: 0,
        hasTax: false,
        taxRate: 0,
      };

      newData.index = this.editIndex;
      newData.item = this.editPayment;

      if (this.editPayment && this.editPayment.Id){
        newData.accountAmountLeft = this.accountAmountLeft + this.editPayment.Amount;
      }

      this.paymentEditorData = newData;
    },
    onPaymentListViewItemClick(dataOut) {
      this.editIndex = dataOut.index;
      this.editPayment = dataOut.item;
      this.reloadDataForPaymentEditor();
  
      this.paymentEditorVisible = true;
    },
    onPaymentListViewItemRemove(data) {
      if (!!data && !!data.item && !!data.item.Id) {
        this.isSavePayment = true;
        removeAccountPayment(data.item.Id, this.workMode).then((result) => {
          if (!result) {
            return;
          }
          if (result.success) {
            this.$message({
              message: "删除支付成功",
              type: "success",
            });
            this.accountModel.AccountPayments.splice(data.index, 1);
            this.handleAccountLoading();
          } else {
            this.$message({
              message: "删除支付失败",
              type: "error",
            });
          }
          this.isSavePayment = false;
        });
      }
    },
    showAddPaymentEditor() {
      this.paymentEditorData = {
        accountAmountLeft: this.accountAmountLeft,
        hasTax: false,
        taxRate: 0,
      };
      
      this.paymentEditorVisible = true;
    },
    async saveAccountModel() {
      this.accountModel.Amount = this.dataIn.accountAmount;
      this.isSavePayment = true;
      this.$emit("savePaymentStart");
      let result = await saveAccount(this.accountModel);
      if (!!result && result.success) {
        this.accountModel.Id = result.data.Id;

        if (this.workMode !== "ContinuePayment") {
          this.loadAccountModel();
        }
      } else {
        this.$message.error(result.message);
      }

      this.isSavePayment = false;
      this.$emit("savePaymentEnd");
      this.handleAccountLoading();
      this.loadAccountModel();
    },
    onPaymentEditorClose() {
      this.paymentEditorVisible = false;
      this.editIndex = -1;
      this.editPayment = null;
    },
    onPaymentEditorCallback(dataOut) {
      if (dataOut.success) {
        if (!!this.workMode && this.workMode == "ContinuePayment") {
          let amount = dataOut.data.TotalAmount;
          if (this.editPayment && this.editPayment.Id){
            amount = dataOut.data.TotalAmount - this.editPayment.Amount;
          }
          if (amount > this.accountModel.Debt) {
            let desc = "";
            if (this.editPayment && this.editPayment.Id){
              desc = `调整金额 ${amount}`;
            }else{
              desc = `付款金额 ${amount}`;
            }
            let msg = `${desc} 不能大于补款金额 ${this.accountModel.Debt}`;
            this.$message.warning(msg);
            this.resetPaymentSubmit();
            return;
            //let msg = `${desc} 大于补款金额 ${this.accountModel.Debt}，确认继续吗?`;
            // this.$confirm(msg, "提示", {
            //   confirmButtonText: "确定",
            //   cancelButtonText: "取消",
            //   type: "warning",
            // })
            //   .then(() => {
            //     this.saveContinuePayment(dataOut);
            //   })
            //   .catch(() => {
            //     let refPaymentEditor =
            //       this.$vueRefStore.getChildrenRef("paymentEditor");
            //     if (!!refPaymentEditor) {
            //       refPaymentEditor.submitBtnDisable = false;
            //     }
            //   });
          } else {
            this.saveContinuePayment(dataOut);
          }
        } else {
          if (dataOut.data.TotalAmount > this.accountAmountLeft){
            let msg = `付款金额 ${dataOut.data.TotalAmount} 不能大于应付金额 ${this.accountAmountLeft}`;
            this.$message.warning(msg);
            this.resetPaymentSubmit();
            return;
          }
          this.accountModel.AccountPayments.push(dataOut.data);
          this.saveAccountModel();
          this.paymentEditorVisible = false;
          this.editIndex = -1;
          this.editPayment = null;
          this.reloadDataForPaymentEditor();
        }
      }
    },
    resetPaymentSubmit(){
      let refPaymentEditor = this.$vueRefStore.getChildrenRef("paymentEditor");
      if (!!refPaymentEditor) {
        refPaymentEditor.submitBtnDisable = false;
      }
    },
    // onPayeeTypeChange() {
    //   if (
    //     this.model.payeeType == 1 &&
    //     this.accountModel.AccountPayments.length > 0
    //   ) {
    //     this.$confirm(
    //       "您已经添加付款，切换付款方式为渠道支付会清除付款，是否继续?",
    //       "提示",
    //       {
    //         confirmButtonText: "确定",
    //         cancelButtonText: "取消",
    //         type: "warning",
    //       }
    //     )
    //       .then(() => {
    //         this.accountModel.AccountPayments = [];
    //         this.handleAccountLoading();
    //       })
    //       .catch(() => {
    //         this.model.payeeType = 0;
    //       });
    //   } else {
    //     this.handleAccountLoading();
    //   }
    // },
    saveContinuePayment(dataOut) {
      let payment =
        dataOut.index >= 0
          ? this.accountModel.AccountPayments[dataOut.index]
          : null;
      if (!!payment) {
        payment.PaymentTypeId = dataOut.data.PaymentTypeId;
        payment.ServiceCharge = dataOut.data.ServiceCharge;
        payment.Amount = dataOut.data.Amount;
        payment.Comment = dataOut.data.Comment;
      } else {
        this.accountModel.AccountPayments.push(dataOut.data);
      }

      this.saveAccountModel();
      this.paymentEditorVisible = false;
      this.editIndex = -1;
      this.editPayment = null;
    },
  },
  watch: {
    dataIn() {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/accountInfo.vue